import React from 'react';  
import './index.css';
import moment from "moment"; 
class InfoDes extends React.Component{
  render(){
    const {data} = this.props;
    const  end = data.get('end_at');
    const  end_time = moment(end*1000).format('YYYY-MM-DD HH:mm:ss'); 
    
    return (
      <div className="info-des">
        <div className="des-title">
          <span>{data.get('title')?data.get('title'):'暂无'}</span>
        </div>
        <div className="des-bottom">
          <span>本节截止时间为：</span>
          <div className="des-time">{end_time}</div>
        </div>
      </div>
      )
  }
}
export default InfoDes;